<div class="main-content">
  <div class="mt-5 d-flex justify-content-center">
    <img alt="Page not found" class="text-center main-image" src="assets/images/backgrounds/page-not-found.svg">
  </div>
  <div class="mt-0 mb-2 d-flex justify-content-center">
    <p class="font-32 primary-text"><span class="bold-font">{{'pageNotFound.ops' | translate}}</span> {{'pageNotFound.errorMessage' | translate}}</p>
  </div>
  <div class="mt-5 mb-5 d-flex justify-content-center">
    <button (click)="goToHomePage()"
            class="m-auto btn btn-primary min-width-200">{{'pageNotFound.goHome' | translate}}</button>
  </div>
</div>
